export default{
    zqdetail:{
        titleState:{
            title1:'账期结算单',
            title2:'账期详情'
        },
        msgState:{
            msg1:'超时未对账，系统自动完成对账',
            msg2:'对账完成后',
            msg3:'个自然日',
            msg4:'还有',
            msg5:'天逾期',
            msg6:'已逾期',
            msg7:'天',
        },
        btnState:{
            btn1:'对账通过',
            btn2:'对账异议',
            btn3:'立即支付',
            btn4:'验票通过',
            btn5:'验票不通过',
            btn6:'修改发票',
            btn7:'申请开票',
            btn8:'查看详情',
            btn9:'不要发票',
            btn10:'需要发票',
        },
        jsdxx:{
            psInfo1:'账期结算单信息',
            psInfo2:'账单单号：',
            psInfo3:'商家名称：',
            psInfo4:'对账日期：',
            psInfo5:'对账期限：',
            psInfo6:'最晚付款日：',
            psInfo7:'应结金额：',
            psInfo8:'结算订单数：',
            psInfo9:'订单总额：',
            psInfo10:'退款订单数：',
            psInfo11:'退款总额：',
            psInfo12:'结算单金额：',
            psInfo13:'结算单日志',
        },
        fapiaoxx:{
            fkInfo1:'发票信息',
            fkInfo2:'可开票金额：',
            fkInfo3:'发票类型：',
            fkInfo4:'发票抬头：',
            fkInfo5:'社会统一信用代码：',
            fkInfo6:'注册地址：',
            fkInfo7:'注册电话：',
            fkInfo8:'开户银行：',
            fkInfo9:'银行账户：',
        },

        kpxx:{
            qxInfo1:'开票状态：',
            qxInfo2:'下载电子发票',
            qxInfo3:'承运单位：',
            qxInfo4:'发票备注：',
            qxInfo5:'配送单号：',
            qxInfo6:'复制单号',
            qxInfo7:'进度跟踪',
            qxInfo8:'您当前暂未申请发票信息',
            qxInfo9:'发票信息',
        },
        table:{
            setp1:'订单编号',
            setp2:'下单时间',
            setp3:'订单金额',
            setp4:'退款金额',
            setp5:'应付金额',
            setp6:'店铺名称',
            setp7:'操作',
        },
        dialogState:{
            dil1:'订单跟踪',
            dil2:'承运单位：',
            dil3:'配送单号：',
            dil4:'确 定',
            dil5:'结算单日志',
            dil6:'操作时间：',
            dil7:'操作人：',
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否需要商家开发票？',
            confirm6:'确认对账信息有误？点击确认，联系平台技术客服',
            confirm7:'请输入验票未通过原因',
            confirm8:'输入验票未通过原因',
            confirm9:'电子发票',
            confirm10:'下载成功',
            confirm11:'复制成功',
        }
        

    }
    
}